// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"ecbae507","221":"57757308","271":"23d393c5","344":"10783499","400":"40e22107","439":"d6f6e085","512":"fc204528","558":"afc9208f","605":"56b99db4","626":"9f1dea99","716":"8a0b7b5b","810":"0823f7dc","923":"089adb48","973":"1cd0510a"}[chunkId] + ".chunk.js";
};